import { render, staticRenderFns } from "./productDes.vue?vue&type=template&id=3870815e&scoped=true"
import script from "./productDes.vue?vue&type=script&lang=js"
export * from "./productDes.vue?vue&type=script&lang=js"
import style0 from "./productDes.vue?vue&type=style&index=0&id=3870815e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3870815e",
  null
  
)

export default component.exports